import { create } from 'zustand'
import { persist } from 'zustand/middleware'

import { type IPost } from 'types/interfaces/ITypes'

interface DiscoverFeedCacheState {
  posts: IPost[]
  updatedAt: number | null
  setPosts: (posts: IPost[]) => void
  clear: () => void
}

export const useDiscoverFeedCacheStore = create<DiscoverFeedCacheState>()(
  persist(
    set => ({
      posts: [],
      updatedAt: null,

      setPosts: posts => {
        set({
          posts,
          updatedAt: Date.now(),
        })
      },

      clear: () => {
        set({
          posts: [],
          updatedAt: null,
        })
      },
    }),
    {
      name: 'discover-feed-cache',
      partialize: state => ({
        posts: state.posts,
        updatedAt: state.updatedAt,
      }),
    }
  )
)